export const ApplicationConstant = {
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    DEV_ENV:'DEV',
    TEST_ENV:'TEST',
    PROD_ENV:'PROD'
}
